import { Link, usePush } from '@dreryk/react-components';

import { translationKeys } from '../translations';

// TODO: DREGAB-4137 Replace with on strong typed paths from common module
const MY_ACCOUNT_PATH = '/moje-konto/logowanie-nfz';

export const NfzLoginLink = (): JSX.Element => {
   const push = usePush();

   const handleClick = (): void => {
      push(MY_ACCOUNT_PATH);
   };

   return <Link testId={'nfzLogin'} label={translationKeys.nfzLogin} block={false} onClick={handleClick} />;
};
